import React from 'react';
import DietPlanTemplateListFunctional from './components/diet-plan-template-list-functional';

const DietPlanTemplateList = () => {
	return <DietPlanTemplateListFunctional />
};

export default DietPlanTemplateList;
